<template>

  <v-dialog
    v-model="show"
    persistent
    fullscreen
    >
    <v-card class="pa-1">
        <v-icon style="float: right" class="hidden-print-only" @click="emitToParent('close')" >mdi-close-circle</v-icon>
          <v-icon style="float: right" class="hidden-print-only" @click="$printThis()" >mdi-printer</v-icon>
        <print-header/>
        <div class="ma-2 caption .font-weight-bold">
            <p style="float: right">{{selected_date | moment('lll')}}</p>
            <p>{{showdata}}</p>
            
        </div>
          <va-credit-sales :showdata="showdata" :show="show" :selected_date="selected_date" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    selected_date: {
          type: String,
        default: ""
    },
    showdata: {
        type: String,
        default:'TCL'
    }
  },
  data: () => ({
    
  }),
  computed: {
  },
  methods: {
       emitToParent (action) {
            this.$emit('DialogEvent', action)
    },
  }
}
</script>
